module.exports = "<div class=\"nav-icon\" [ngClass]=\"{ 'open': open }\">\n  <span class=\"nav-icon-bar-middle\"></span>\n</div>\n"